import { useEffect, useState } from 'react';
import ProcedureList from '@src/cache/ProcedureList';

interface Props {
  id: string;
}

function ProcedureName({ id }: Props) {
  const { getList: getProcedures } = ProcedureList();
  const [display, setDisplay] = useState('');
  useEffect(() => {
    getProcedures(id).then((procedures) => {
      const procedure = procedures.find((c) => c.id === id);
      if (procedure) {
        let label = [procedure.name, procedure.variant]
          .filter(Boolean)
          .join(' ');

        setDisplay(label);
      } else {
        setDisplay(id);
      }
    });
  }, [getProcedures, id]);
  return <span>{display}</span>;
}

export default ProcedureName;
